// extracted by mini-css-extract-plugin
export default {"marginTop":"Location_marginTop__EtdjL","sectionTitle":"Location_sectionTitle__OpOhN"};